// extracted by mini-css-extract-plugin
export default {"gridContainer":"Grid_gridContainer__AstOO","noGrid":"Grid_noGrid__-6wpJ","reviews":"Grid_reviews__01Jkk"};